import React, { memo, useCallback } from 'react';
import { CellRendererParams } from 'routes/BudgetModule/config/types';
import {
    HrMappingFieldEnum,
    HrMappingValue,
    HrPositionMapping,
} from 'routes/HumanResourcesModule/Settings/HrPositionMapping/helpers/type';
import { Box } from '@mui/material';

import {
    PutPositionMappingPayload,
    usePutPositionMapping,
} from 'routes/HumanResourcesModule/Settings/HrPositionMapping/helpers/hooks/hrPositionMapping';
import { getPositionValue } from 'routes/HumanResourcesModule/Settings/HrPositionMapping/helpers/gridHelpers';
import MappingValueSelector from '../MappingValueSelector';
import { StatusSelectorOptions } from 'components/SharedComponents/StatusSelector/StatusSelector';

type CustomParams = {
    fieldToUpdate: keyof PutPositionMappingPayload;
    fieldEnum: HrMappingFieldEnum;
};

type Props = CellRendererParams<HrPositionMapping, HrMappingValue | null> &
    CustomParams;

function HrMappingSelectorCellRenderer({
    value,
    data,
    fieldToUpdate,
    fieldEnum,
}: Props) {
    const updateMappingMutation = usePutPositionMapping();

    const handleChange = useCallback(
        (e: StatusSelectorOptions<HrPositionMapping | string>) => {
            const newValue = e.value;
            updateMappingMutation.mutate({
                [fieldToUpdate]: newValue,
                // TODO: try to remove this non-null assertion
                hrPositionMappingIds: [data!.id],
            });
        },
        [JSON.stringify(data), updateMappingMutation],
    );
    const fieldEnumChoices = Object.values(fieldEnum).map((enumValue) => ({
        value: enumValue,
        label: getPositionValue(enumValue),
    }));

    return (
        <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            height="100%"
            width="100%"
        >
            <MappingValueSelector
                selectedValue={value}
                enabled={Boolean(data)}
                handleChange={handleChange}
                choices={fieldEnumChoices}
            />
        </Box>
    );
}

export default memo(HrMappingSelectorCellRenderer);
